import React from 'react'

// import LandingPage from '../Preview/LandingPage'
import GoldStakeSchemeTab from '../Tabs/GoldStakeSchemeTab'
import GoldStakeSheme from './GoldStakeSheme'
import { useDispatch } from 'react-redux'
import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice'
import QuestionAnswers from './QuestionAnswers'

const SchemeManagement = () => {
    const dispatch = useDispatch()
    // const tabTitle = ["Schemes", "Q&A's"]
    const tabTitle = ["Schemes"]


    const tabComponent = [<GoldStakeSheme />,<QuestionAnswers />]
    dispatch(setHeaderName('Scheme Management'));

    return (
        <div>
            <GoldStakeSchemeTab tabTitle={tabTitle} tabComponent={tabComponent} />
        </div>
    )
}

export default SchemeManagement